import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { BookingsAppointmentTypeModel } from './typings/bookings.appointment-type';
import { BookingsRequestModel }         from './typings/bookings.request';
import { BookingsService }              from './bookings.service';
import { CodeTypeModel }                from '../core/models/code-type';
import { CompanyService }               from '../companies/company.service';
import { DateParserService }            from '../core/services/date-parser.service';
import { MessagesService }              from '../messages/messages.service';
import { SessionService }               from '../sessions/session.service';

@Component({
  selector   : 'wor-booking-request',
  template: require('./bookings.request.component.html')
})
export class BookingsRequestComponent {
  @BlockUI('bookingRequestBlock') block : NgBlockUI;

  @Input() appointmentTypes: Array<BookingsAppointmentTypeModel>;
  @Input() bodyTypes       : Array<CodeTypeModel>;
  @Input() contactTypes    : Array<CodeTypeModel>;
  @Input() request         : BookingsRequestModel;

  regoLabel : string = this.sessionService.countrySettings().rego_label;;

  constructor (
    public  activeModal      : NgbActiveModal,
    @Inject(forwardRef(() => BookingsService))
    private bookingsService  : BookingsService,
    public  companyService   : CompanyService,
    private dateParserService: DateParserService,
    private messagesService  : MessagesService,
    private sessionService   : SessionService,
    private translateService : TranslateService
  ) {}

  ngOnInit () : void {
    const company = this.sessionService.company();

    if ( company.company_variable_fields.plate_number_name ) {
      this.regoLabel = company.company_variable_fields.plate_number_name;
    }

    this.request.start_date = this.dateParserService.format(this.request.local_start_time, 'YYYY-MM-DD');
    this.request.start_time = this.dateParserService.format(this.request.local_start_time, 'HH:mm:ss');
  }

  approve () : void {
    this.updateLocalStartTime();

    this.activeModal.close({
      message     : this.translateService.instant('JOB_STATUS_TYPES.BOOKED'),
      request     : this.request,
      skipApproval: false
    });
  }

  delete () : void {
    this.bookingsService.deleteRequest(this.request)
    .then(() => this.activeModal.close({
        deleted     : true,
        message     : this.translateService.instant('JS_SPACE.MESSAGES.DELETED.DELETED'),
        request     : this.request,
        skipApproval: true
      }))
    .catch(error => this.messagesService.error(error));
  }

  formatterFn = ( mechanic : any ) => {
    return typeof mechanic === 'object'
      ? mechanic.display_name
      : mechanic;
  }

  onMechanicChange ( mechanic : any ) : void {
    this.request.mechanic_id           = mechanic.id;
    this.request.mechanic_display_name = mechanic.display_name;

    this.verifyAvailability();
  }

  update () : void {
    this.updateLocalStartTime();

    this.activeModal.close({
      message     : this.translateService.instant('JS_SPACE.MESSAGES.UPDATED.UPDATED'),
      request     : this.request,
      skipApproval: true
    });
  }

  searchFn = ( query : string ) => {
    return this.bookingsService.getMechanics(query);
  }

  updateLocalStartTime () : void {
    this.request.local_start_time = this.bookingsService.formatLocalStartTime(this.request);
  }

  verifyAvailability () : void {
    if ( !!this.request.start_date && !!this.request.start_time && !!this.request.mechanic_display_name ) {
      this.bookingsService.validateBookingTime(this.request)
      .then(() => {
        //
      })
      .catch(error => this.messagesService.error(error));
    }
  }

  viewDiary () : void {
    this.bookingsService.viewDiary(this.request);
  }
}
